import React, { Fragment, useEffect, useState } from "react";
import { FullScreenLoader } from "../components/Custom-Spinner";
import { callApi } from "../../utils/mainapp-api";
import "@ahrvocomply/ahrvo-comply-react-sdk-sandbox/dist/index.css";
import { CustomHeader } from "../../layout/header";
import { TRUSTLY_CDN_URL } from "../../constant";

export default function UserDetails() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    user: {},
    is_from_business: false,
    country_status_color: "warning",
    omniscore: "",
    creditRatingStatus: null,
    front_base: "",
    back_base: "",
    image_from_liveness: "",
    image_from_selfie: "",
    areaCodeMatch: false,
    last_ip_address_check: false,
  });

  const [color, setColor] = useState("");
  const [status, setStatus] = useState("No Status");
  const [riskDiligenceScore, setRiskDiligenceScore] = useState("danger");

  useEffect(() => {
    getUserDetails();
  }, []);
  const getUserDetails = async () => {
    try {
      const response = await callApi(
        "get",
        "contacts/get_user_details_new",
        {},
        false
      );
      setData(response);

      const color = getColor(response.user, response.riskSettings);
      setStatus(getStatus(response.user, response.riskSettings));
      setColor(color);
      setRiskDiligenceScore(
        getRiskDiligence(response.user.risk_by_admin || response.risk_score)
      );
      setLoading(false);
    } catch (error) {
      console.log("error", error);
    }
  };

  function getColor(user, riskSettings) {
    let risk_by_admin = parseInt(user.risk_by_admin);
    let user_risk_score = parseInt(user.risk_score);
    let country = user.country;

    if (user.active == "False") {
      return "danger";
    } else {
      let status = null;
      let risk_score = 0;
      if (risk_by_admin) {
        risk_score = risk_by_admin;
      } else {
        risk_score = user_risk_score;
      }
      riskSettings.forEach((item) => {
        if (item.country == country) {
          if (
            window.math.eval(`${risk_score} ${item.constraint} ${item.risk}`)
          ) {
            status = item.metric;
          }
        }
      });
      if (status) {
        if (status == "Approved") {
          return "success";
        } else if (status == "Pending") {
          return "warning";
        } else if (status == "Rejected") {
          return "danger";
        } else {
          return "primary";
        }
      }
      if (risk_score >= 1 && risk_score <= 3) {
        return "success";
      } else if (risk_score == 4) {
        return "warning";
      } else if (risk_score == 5) {
        return "danger";
      } else if (risk_score == 0) {
        return "primary";
      }
    }
  }

  function getStatus(user, riskSettings) {
    let risk_by_admin = parseInt(user.risk_by_admin);
    let user_risk_score = parseInt(user.risk_score);
    let country = user.country;

    if (user.active == "False") {
      return "Suspended";
    } else {
      let status = null;
      let risk_score = 0;
      if (risk_by_admin) {
        risk_score = risk_by_admin;
      } else {
        risk_score = user_risk_score;
      }

      riskSettings.forEach((item) => {
        if (item.country == country) {
          if (
            window.math.eval(`${risk_score} ${item.constraint} ${item.risk}`)
          ) {
            status = item.metric;
          }
        }
      });

      if (status) {
        return status;
      }

      if (risk_score >= 1 && risk_score <= 3) {
        return "Approved";
      } else if (risk_score == 4) {
        return "Pending";
      } else if (risk_score == 5) {
        return "Rejected";
      } else if (risk_score == 0) {
        return "No Status";
      }
    }
  }

  const getRiskDiligence = (user_score) => {
    if (user_score >= 1 && user_score <= 2) return "SDD";
    else if (user_score == 3) return "CDD";
    else if (user_score >= 4 && user_score <= 5) return "EDD";
    else return "SDD";
  };

  if (loading) return <FullScreenLoader />;
  const {
    is_from_business,
    user,
    country_status_color,
    omniscore,
    creditRatingStatus,
    front_base,
    back_base,
    image_from_liveness,
    image_from_selfie,
    areaCodeMatch,
    last_ip_address_check,
    last_checked_on,
    submitted_by,
  } = data;
  return (
    <div className="nk-content">
      <div className="container-fluid">
        <CustomHeader />

        <div className="container-xl wide-lg">
          <div className="nk-content-inner">
            <div className="nk-content-body">
              <div className="nk-content"></div>
              <div class="nk-block">
                {is_from_business && (
                  <div class="row gy-5" style={{ justifyContent: "center" }}>
                    <div class="col-lg-7">
                      <div class="nk-block-head">
                        <div class="nk-block-head-content">
                          <h5 class="nk-block-title title">
                            Business Information
                          </h5>
                        </div>
                      </div>
                      <div class="card card-bordered">
                        <ul class="data-list is-compact">
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">Business Name</div>
                              <div class="data-value">
                                {user.business.companyName}
                              </div>
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">Business Address</div>
                              <div class="data-value">
                                {user.business.companyAddress}
                              </div>
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">
                                Business Phone Number
                              </div>
                              <div class="data-value">
                                {user.business.companyPhoneNumber}
                              </div>
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">
                                Business Email Address
                              </div>
                              <div class="data-value">
                                {user.business.companyEmailAddress}
                              </div>
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">
                                Business Linkedin Profile
                              </div>
                              <div class="data-value">
                                {user.business.companyLinkedinProfile}
                              </div>
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">
                                Business Tax ID Number
                              </div>
                              <div class="data-value">
                                {user.business.companyTaxIDNumber}
                              </div>
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">Business CompanyType</div>
                              <div class="data-value">
                                {user.business.companyType}
                              </div>
                            </div>
                          </li>

                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">Business Industry</div>
                              <div class="data-value">
                                {user.business.companyIndustry}
                              </div>
                            </div>
                          </li>

                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">Business Filing Date</div>
                              <div class="data-value">
                                {user.business.companyFilingDate}
                              </div>
                            </div>
                          </li>

                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">
                                Business Country Of Registration
                              </div>
                              <div class="data-value">
                                {user.business.countryOfRegistration}
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}

                {!is_from_business && (
                  <div class="row gy-5">
                    <div class="col-lg-5">
                      <div class="nk-block-head">
                        <div class="nk-block-head-content">
                          <h5 class="nk-block-title title">
                            Onboarding Status Details
                          </h5>
                          <p>Submission date, approve date, status etc.</p>
                        </div>
                      </div>
                      <div class="card card-bordered">
                        <ul class="data-list is-compact">
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">Submitted By</div>
                              <div class="data-value">
                                {submitted_by ? submitted_by : "No Status"}
                              </div>
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">Submitted At</div>
                              <div class="data-value">
                                {user.submitted_date
                                  ? user.submitted_date
                                  : "No Status"}
                              </div>
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">Onboarding Status</div>
                              <div class="data-value">
                                <span
                                  id="status_badge_onboarding"
                                  class={
                                    "badge badge-dim badge-sm badge-outline-" +
                                    color
                                  }
                                >
                                  {status}
                                </span>
                              </div>
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">Last Checked At</div>
                              <div class="data-value">
                                {last_checked_on
                                  ? last_checked_on
                                  : "No Status"}
                              </div>
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">User Status</div>
                              <div
                                class={`badge badge-dim badge-sm badge-outline-${
                                  user.active ? "success" : "danger"
                                }`}
                              >
                                {user.active ? "Active" : "Suspended"}
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                      <div class="nk-block-head">
                        <div class="nk-block-head-content">
                          <h5 class="nk-block-title title">
                            Ahrvo Comply Risk Analysis
                          </h5>
                          <p>Applicant risk calculations</p>
                        </div>
                      </div>
                      <div class="card card-bordered">
                        <ul class="data-list is-compact">
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">
                                User Country Score
                                <em
                                  class="card-hint icon ni ni-help-fill"
                                  data-toggle="tooltip"
                                  data-placement="left"
                                  title="User Country Score is the FATF based risk score of the country the user is onboarding from"
                                ></em>
                              </div>
                              <div
                                class={
                                  "badge badge-dim badge-sm badge-outline-" +
                                  "warning"
                                }
                              >
                                {user.user_country_score || "No Status"}
                              </div>
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">
                                User Risk Score
                                <em
                                  class="card-hint icon ni ni-help-fill"
                                  data-toggle="tooltip"
                                  data-placement="left"
                                  title="User Risk Score is based on Country Risk Score and individual onboarding checks like Face Match, Liveness, Check, Age and Gender Check, etc."
                                ></em>
                              </div>
                              <div
                                id="status_badge_user_risk_score"
                                class={
                                  "badge badge-dim badge-sm badge-outline-" +
                                  color
                                }
                              >
                                {user.risk_by_admin || user.risk_score}
                              </div>
                            </div>
                          </li>

                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">
                                Risk Diligence Score
                                <em
                                  class="card-hint icon ni ni-help-fill"
                                  data-toggle="tooltip"
                                  data-placement="left"
                                  title="Is determined based on the User Risk Score. Where Risk Scores equal to 1 and 2 = Simple Due Diligence, 3 = Customer Due Diligence, 4 and 5 = Enhanced Due Diligence"
                                ></em>
                              </div>
                              <div
                                className={`badge badge-dim badge-sm badge-outline-${
                                  riskDiligenceScore == "EDD"
                                    ? "danger"
                                    : riskDiligenceScore == "CDD"
                                    ? "warning"
                                    : riskDiligenceScore == "SDD"
                                    ? "success"
                                    : "info"
                                }
                                  `}
                              >
                                {riskDiligenceScore}
                              </div>
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">
                                Credit Risk Score
                                <em
                                  class="card-hint icon ni ni-help-fill"
                                  data-toggle="tooltip"
                                  data-placement="left"
                                  title="The credit risk score is 1-100, and determined by Kount (Equifax) using the historical transactions and purchases of the user. The higher the score, the lower the users credit and transaction risk."
                                ></em>
                              </div>

                              <div
                                class={`badge badge-dim badge-sm badge-outline-${
                                  omniscore ? "success" : "info"
                                }`}
                              >
                                {omniscore || "No Status"}
                              </div>
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">
                                Credit Rating Status
                                <em
                                  class="card-hint icon ni ni-help-fill"
                                  data-toggle="tooltip"
                                  data-placement="left"
                                  title="The credit rating status of Approved, Review, or Declined are determined by Kount (Equifax) using the historical transactions and purchases of the user."
                                ></em>
                              </div>
                              {creditRatingStatus ? (
                                creditRatingStatus == "A" ? (
                                  <div class="badge badge-dim badge-sm badge-outline-success">
                                    Approved
                                  </div>
                                ) : creditRatingStatus == "R" ? (
                                  <div class="badge badge-dim badge-sm badge-outline-warning">
                                    Review
                                  </div>
                                ) : (
                                  <div class="badge badge-dim badge-sm badge-outline-danger">
                                    Declined
                                  </div>
                                )
                              ) : (
                                <div class="badge badge-dim badge-sm badge-outline-info">
                                  No Status
                                </div>
                              )}
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">
                                Face Match
                                <em
                                  class="card-hint icon ni ni-help-fill"
                                  data-toggle="tooltip"
                                  data-placement="left"
                                  title="Once users pass Liveness testing to confirm they are real, their face is compared to the face on the ID uploaded to determine if they are the same person."
                                ></em>
                              </div>
                              {user.faces_match == true ? (
                                <div class="badge badge-dim badge-sm badge-outline-success">
                                  Pass
                                </div>
                              ) : user.faces_match == false ? (
                                <div class="badge badge-dim badge-sm badge-outline-danger">
                                  Fail
                                </div>
                              ) : (
                                <div class="badge badge-dim badge-sm badge-outline-info">
                                  No Status
                                </div>
                              )}
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">
                                Liveness Check
                                <em
                                  class="card-hint icon ni ni-help-fill"
                                  data-toggle="tooltip"
                                  data-placement="left"
                                  title="Users are asked to smile, blink, and turn their head in random order to determine if they are a real person and to eliminate spoofing"
                                ></em>
                              </div>
                              {user.liveness_check == true ? (
                                <div class="badge badge-dim badge-sm badge-outline-success">
                                  Pass
                                </div>
                              ) : user.liveness_check == false ? (
                                <div class="badge badge-dim badge-sm badge-outline-danger">
                                  Fail
                                </div>
                              ) : (
                                <div class="badge badge-dim badge-sm badge-outline-info">
                                  No Status
                                </div>
                              )}
                            </div>
                          </li>
                          {/*   <li class="data-item">
                          <div class="data-col">
                            <div class="data-label">
                              Gender Check
                              <em
                                class="card-hint icon ni ni-help-fill"
                                data-toggle="tooltip"
                                data-placement="left"
                                title="The gender the user enters during onboarding is compared to the gender predicted by our system to determine if they are a match"
                              ></em>
                            </div>
                            {user.gender_check == true ? (
                              <div class="badge badge-dim badge-sm badge-outline-success">
                                Pass
                              </div>
                            ) : user.gender_check == false ? (
                              <div class="badge badge-dim badge-sm badge-outline-danger">
                                Fail
                              </div>
                            ) : (
                              <div class="badge badge-dim badge-sm badge-outline-info">
                                No Status
                              </div>
                            )}
                          </div>
                        </li>
                        <li class="data-item">
                          <div class="data-col">
                            <div class="data-label">
                              Age Check
                              <em
                                class="card-hint icon ni ni-help-fill"
                                data-toggle="tooltip"
                                data-placement="left"
                                title="The age the user enters during onboarding is compared to the age predicted by our system to determine if they are a match. The current age range for a match is plus or minus 5 years."
                              ></em>
                            </div>
                            {user.age_check == true ? (
                              <div class="badge badge-dim badge-sm badge-outline-success">
                                Pass
                              </div>
                            ) : user.age_check == false ? (
                              <div class="badge badge-dim badge-sm badge-outline-danger">
                                Fail
                              </div>
                            ) : (
                              <div class="badge badge-dim badge-sm badge-outline-info">
                                No Status
                              </div>
                            )}
                          </div>
                        </li> */}
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">
                                Email Verified
                                <em
                                  class="card-hint icon ni ni-help-fill"
                                  data-toggle="tooltip"
                                  data-placement="left"
                                  title="User verified their email address using a one-time password"
                                ></em>
                              </div>
                              {user.email_conf == true ? (
                                <div class="badge badge-dim badge-sm badge-outline-success">
                                  Pass
                                </div>
                              ) : (
                                <div class="badge badge-dim badge-sm badge-outline-danger">
                                  Fail
                                </div>
                              )}
                            </div>
                          </li>

                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">
                                Phone Verified
                                <em
                                  class="card-hint icon ni ni-help-fill"
                                  data-toggle="tooltip"
                                  data-placement="left"
                                  title="User verified their phone number using a one-time password"
                                ></em>
                              </div>
                              {user.otp_ver == true ? (
                                <div class="badge badge-dim badge-sm badge-outline-success">
                                  Pass
                                </div>
                              ) : (
                                <div class="badge badge-dim badge-sm badge-outline-danger">
                                  Fail
                                </div>
                              )}
                            </div>
                          </li>

                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">
                                Area Code Match
                                <em
                                  class="card-hint icon ni ni-help-fill"
                                  data-toggle="tooltip"
                                  data-placement="left"
                                  title="User verified their phone number using a one-time password"
                                ></em>
                              </div>
                              {user.otp_ver != true ? (
                                <div class="badge badge-dim badge-sm badge-outline-info">
                                  Unverified Number
                                </div>
                              ) : areaCodeMatch == true ? (
                                <div class="badge badge-dim badge-sm badge-outline-success">
                                  Pass
                                </div>
                              ) : (
                                <div class="badge badge-dim badge-sm badge-outline-danger">
                                  Fail
                                </div>
                              )}
                            </div>
                          </li>

                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">
                                Nationality per ID
                                <em
                                  class="card-hint icon ni ni-help-fill"
                                  data-toggle="tooltip"
                                  data-placement="left"
                                  title="The country of nationality extracted from the MRZ of the ID uploaded during onboarding."
                                ></em>
                              </div>

                              {user.nationality_id == null ? (
                                <div class="badge badge-dim badge-sm badge-outline-info">
                                  Undetected
                                </div>
                              ) : (
                                <div class="badge badge-dim badge-sm badge-outline-success">
                                  {user.nationality_id}
                                </div>
                              )}
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">
                                MRZ Type
                                <em
                                  class="card-hint icon ni ni-help-fill"
                                  data-toggle="tooltip"
                                  data-placement="left"
                                  title="Government IDs have different MRZ types. The MRZ Types can be either 1, 2, or 3. MRZ Type 1 and 2 are for all ID except passports, which are TD3."
                                ></em>
                              </div>
                              {user.mrz_type == null ? (
                                <div class="badge badge-dim badge-sm badge-outline-info">
                                  No MRZ detected
                                </div>
                              ) : (
                                <div class="badge badge-dim badge-sm badge-outline-success">
                                  {user.mrz_type}
                                </div>
                              )}
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">
                                MRZ Match
                                <em
                                  class="card-hint icon ni ni-help-fill"
                                  data-toggle="tooltip"
                                  data-placement="left"
                                  title="The MRZ extracted by our system is compared to the document type selected by the user to determine if there is a match."
                                ></em>
                              </div>
                              {user.mrz_match == true ? (
                                <div class="badge badge-dim badge-sm badge-outline-success">
                                  Pass
                                </div>
                              ) : user.mrz_match == false ? (
                                <div class="badge badge-dim badge-sm badge-outline-danger">
                                  Fail
                                </div>
                              ) : (
                                <div class="badge badge-dim badge-sm badge-outline-info">
                                  No MRZ Match
                                </div>
                              )}
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">
                                AML and PEP
                                <em
                                  class="card-hint icon ni ni-help-fill"
                                  data-toggle="tooltip"
                                  data-placement="left"
                                  title="AML and PEP screening is determined by searching the person or businesses information against international and domestic watchlist; and politically exposed persons list."
                                ></em>
                              </div>
                              {user.aml_and_pep_check == true ? (
                                <div class="badge badge-dim badge-sm badge-outline-success">
                                  Pass
                                </div>
                              ) : user.aml_and_pep_check == false ? (
                                <div class="badge badge-dim badge-sm badge-outline-danger">
                                  Fail
                                </div>
                              ) : (
                                <div class="badge badge-dim badge-sm badge-outline-info">
                                  No Status
                                </div>
                              )}
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">
                                Last IP Address Check
                                <em
                                  class="card-hint icon ni ni-help-fill"
                                  data-toggle="tooltip"
                                  data-placement="left"
                                  title="The IP address of the user is compared to the country on their ID and the country they selected as their residence during onboarding to determine if there is a match. This updates every time a user interacts with the system."
                                ></em>
                              </div>
                              {last_ip_address_check == true ? (
                                <div class="badge badge-dim badge-sm badge-outline-success">
                                  Pass
                                </div>
                              ) : last_ip_address_check == false ? (
                                <div class="badge badge-dim badge-sm badge-outline-danger">
                                  Fail
                                </div>
                              ) : (
                                <div class="badge badge-dim badge-sm badge-outline-info">
                                  No Status
                                </div>
                              )}
                            </div>
                          </li>
                        </ul>
                      </div>

                      <div class="nk-block-head">
                        <div class="nk-block-head-content">
                          <h5 class="nk-block-title title">
                            Linked Bank Account
                          </h5>
                          <p>Below are the linked bank account of user.</p>
                        </div>
                      </div>
                      <div class="card card-bordered">
                        {data.linked_bank_account.length > 0 ? (
                          <ul class="data-list is-compact">
                            {data.linked_bank_account.map((item) => {
                              if (item.type == "brite")
                                return <RenderBrite item={item} />;
                              if (item.type == "trustly_data")
                                return <RenderTrustly item={item} />;
                              if (item.type == "brankas")
                                return <RenderBrankas item={item} />;
                              if (item.type == "mx")
                                return <RenderMX item={item} />;
                              return null;
                            })}
                          </ul>
                        ) : (
                          <p style={{ padding: "1rem" }}>
                            No linked bank account
                          </p>
                        )}
                      </div>
                    </div>
                    <div class="col-lg-7">
                      <div class="nk-block-head">
                        <div class="nk-block-head-content">
                          <h5 class="nk-block-title title">
                            Applicant Information
                          </h5>
                          <p>
                            Basic info, like name, phone, address, country etc.
                          </p>
                        </div>
                      </div>
                      <div class="card card-bordered">
                        <ul class="data-list is-compact">
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">First Name</div>
                              <div class="data-value">{user.first_name}</div>
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">Last Name</div>
                              <div class="data-value">{user.last_name}</div>
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">Email Address</div>
                              <div class="data-value">{user.email}</div>
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">Phone Number</div>
                              <div class="data-value text-soft">
                                <em>{user.phone}</em>
                              </div>
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">Date of Birth</div>
                              <div class="data-value">{user.dob}</div>
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">Gender</div>
                              <div class="data-value">{user.gender}</div>
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">Full Address</div>
                              <div class="data-value">{user.address}</div>
                            </div>
                          </li>
                          {user.telegram_username && (
                            <li class="data-item">
                              <div class="data-col">
                                <div class="data-label">Wallet Address</div>
                                <div class="data-value">
                                  {user.telegram_username}
                                </div>
                              </div>
                            </li>
                          )}
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">Country of Residence</div>
                              <div class="data-value">{user.country}</div>
                            </div>
                          </li>
                          {user.country == "United States" && (
                            <li class="data-item">
                              <div class="data-col">
                                <div class="data-label">State</div>
                                <div class="data-value">
                                  {user?.states?.name}
                                </div>
                              </div>
                            </li>
                          )}

                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">City</div>
                              <div class="data-value">{user.city}</div>
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">Zipcode</div>
                              <div class="data-value">{user.zipcode}</div>
                            </div>
                          </li>
                          {user.tax_id_number && (
                            <li class="data-item">
                              <div class="data-col">
                                <div class="data-label">Tax ID Number</div>
                                <div class="data-value">
                                  {user.tax_id_number}
                                </div>
                              </div>
                            </li>
                          )}

                          {user.legal_business_name && (
                            <li class="data-item">
                              <div class="data-col">
                                <div class="data-label">
                                  Legal Business Name
                                </div>
                                <div class="data-value">
                                  {user.legal_business_name}
                                </div>
                              </div>
                            </li>
                          )}

                          {user.role_at_company && (
                            <li class="data-item">
                              <div class="data-col">
                                <div class="data-label">Role at Company</div>
                                <div class="data-value">
                                  {user.role_at_company}
                                </div>
                              </div>
                            </li>
                          )}
                        </ul>
                      </div>
                      <div class="nk-block-head">
                        <div class="nk-block-head-content">
                          <h5 class="nk-block-title title">
                            Uploaded Documents
                          </h5>
                          <p>Below are the users uploaded documents.</p>
                        </div>
                      </div>
                      <div class="card card-bordered">
                        <ul class="data-list is-compact">
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">Document Type</div>
                              <div
                                class="data-value"
                                style={{ textTransform: "capitalize" }}
                              >
                                {user.doc_type}
                              </div>
                            </div>
                          </li>

                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">ID Issuance Date</div>
                              <div class="data-value" id="id_issuance">
                                {user.id_issuance_date}
                              </div>
                            </div>
                          </li>

                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">ID Expiry Date</div>
                              <div class="data-value" id="id_expiry">
                                {user.id_expiry_date}
                              </div>
                            </div>
                          </li>
                          <script></script>

                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">Front Side</div>
                              <div class="data-value doc_image_container">
                                <img
                                  class="doc_image"
                                  id="front_image"
                                  alt=""
                                  src={front_base}
                                />
                              </div>
                            </div>
                          </li>
                          <li class="data-item">
                            <div class="data-col">
                              <div class="data-label">Back Side</div>
                              <div class="data-value doc_image_container">
                                <img
                                  class="doc_image"
                                  id="back_image"
                                  alt=""
                                  src={back_base}
                                />
                              </div>
                            </div>
                          </li>

                          {image_from_liveness && (
                            <li class="data-item">
                              <div class="data-col">
                                <div class="data-label">
                                  Face Image From Liveness
                                </div>
                                <div class="data-value doc_image_container">
                                  <img
                                    class="doc_image"
                                    id="back_image"
                                    alt=""
                                    src={image_from_liveness}
                                  />
                                </div>
                              </div>
                            </li>
                          )}

                          {image_from_selfie && (
                            <li class="data-item">
                              <div class="data-col">
                                <div class="data-label">
                                  Face Image From Selfie
                                </div>
                                <div class="data-value doc_image_container">
                                  <img
                                    class="doc_image"
                                    id="back_image"
                                    alt=""
                                    src={image_from_selfie}
                                  />
                                </div>
                              </div>
                            </li>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const RenderBrite = ({ item }) => {
  return (
    <li
      class="data-item"
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "#eee",
          paddingLeft: "1rem",
          paddingRight: "1rem",
          borderRadius: "8px",
          paddingTop: "0.5rem",
          paddingBottom: "0.5rem;padding:2rem;padding-top: 1rem",
          paddingBottom: "1rem",
        }}
      >
        <div style={{ marginTop: "0.4rem" }}>
          <p style={{ marginBottom: "0.5rem" }}>Name - {item.name}</p>
          <p style={{ marginBottom: "0.5rem" }}>Partner Name - Brite</p>
          <p style={{ marginBottom: "0.5rem" }}>
            Holder Number - {item.holder}
          </p>
          <p style={{ marginBottom: "0.5rem" }}>BBAN - {item.bban}</p>
          <p style={{ marginBottom: "0.5rem" }}>
            Balance Amount - ${item.balance}
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Currency Code - {item.currency_id}
          </p>
        </div>
      </div>
    </li>
  );
};

const RenderTrustly = ({ item }) => {
  const transactionDetails = item.transactionDetails;
  const transaction = transactionDetails.transaction;
  const accountBalance = item.accountBalance.accountBalance;
  const account = accountBalance.account;
  return (
    <li
      class="data-item"
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "#eee",
          paddingLeft: "1rem",
          paddingRight: "1rem",
          borderRadius: "8px",
          paddingTop: "0.5rem",
          paddingBottom: "0.5rem;padding:2rem;padding-top: 1rem",
          paddingBottom: "1rem",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            style={{ maxWidth: "5rem" }}
            src={`${TRUSTLY_CDN_URL}${item.transactionDetails.transaction.payment.paymentProvider.paymentProviderId}.png`}
          />
        </div>
        <div style={{ marginTop: "0.4rem" }}>
          <p style={{ marginBottom: "0.5rem" }}>Bank Name - {account.name}</p>
          <p style={{ marginBottom: "0.5rem" }}>Partner Name - Trustly</p>
          <p style={{ marginBottom: "0.5rem" }}>
            Account Number(last 4 digits) - {account.accountNumberLastFour}
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Name on Account - {account.nameOnAccount}
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Balance Amount - ${accountBalance.amount}
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Currency Code - {accountBalance.currency}
          </p>
        </div>
      </div>
    </li>
  );
};

const RenderBrankas = ({ item }) => {
  return (
    <li
      class="data-item"
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "#eee",
          paddingLeft: "1rem",
          paddingRight: "1rem",
          borderRadius: "8px",
          paddingTop: "0.5rem",
          paddingBottom: "0.5rem;padding:2rem;padding-top: 1rem",
          paddingBottom: "1rem",
        }}
      >
        <div style={{ marginTop: "0.4rem" }}>
          {item.statements.length == 0 && <p>No statements found</p>}
          {item.statements.map((statment, innerIndex) => {
            <div
              key={"brankas-statement" + innerIndex}
              style={{
                marginTop: "0.4rem",
                flex: 1,
                paddingLeft: "1rem",
              }}
            >
              <p style={{ margin: 0, marginBottom: "0.5rem" }}>
                Bank Code - {statment.bank_code}
              </p>
              <div>
                {statment.account_statements.length == 0 && (
                  <p>No account statements found</p>
                )}

                {statment.account_statements.map(
                  ({ account }, accountIndex) => {
                    return (
                      <div
                        key={"brankas-account" + accountIndex}
                        style={{
                          display: "flex",
                        }}
                      >
                        <p style={{ margin: 0, fontSize: "0.8rem" }}>
                          {account.account_number}
                        </p>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "0.8rem",
                            marginLeft: "2rem",
                          }}
                        >
                          {account.holder_name}
                        </p>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "0.8rem",
                            marginLeft: "2rem",
                          }}
                        >
                          {account.balance.decimal.num}
                        </p>
                      </div>
                    );
                  }
                )}
              </div>
            </div>;
          })}
        </div>
      </div>
    </li>
  );
};

const RenderMX = ({ item }) => {
  const transactionDetails = item.transactionDetails;
  const membersDetails = item.membersDetails;
  const accountsDetails = item.accountsDetails;

  return (
    <li
      class="data-item"
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "#eee",
          paddingLeft: "1rem",
          paddingRight: "1rem",
          borderRadius: "8px",
          paddingTop: "0.5rem",
          paddingBottom: "0.5rem;padding:2rem;padding-top: 1rem",
          paddingBottom: "1rem",
        }}
      >
        {accountsDetails.map((account, accountIndex) => {
          const date = new Date(account.updated_at);
          const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
          const monthsOfYear = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ];

          const dayOfWeek = daysOfWeek[date.getUTCDay()];
          const dayOfMonth = String(date.getUTCDate()).padStart(2, "0");
          const month = monthsOfYear[date.getUTCMonth()];
          const year = date.getUTCFullYear();
          const hours = String(date.getUTCHours()).padStart(2, "0");
          const minutes = String(date.getUTCMinutes()).padStart(2, "0");
          const seconds = String(date.getUTCSeconds()).padStart(2, "0");

          const update_at_datetime = `${dayOfWeek}, ${dayOfMonth} ${month} ${year} ${hours}:${minutes}:${seconds} GMT`;
          return (
            <div
              style={{
                marginTop: "0.4rem",
                border: "1px #dfdfdf solid",
                padding: "15px",
                borderRadius: "8px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "15px",
                }}
              >
                <img
                  style={{ maxWidth: "5rem" }}
                  src={membersDetails.small_logo_url}
                />
              </div>

              <p style={{ marginBottom: "0.5rem" }}>
                Bank Name - {account.name}
              </p>
              <p style={{ marginBottom: "0.5rem" }}>
                Partner Name - MX Connect
              </p>
              <p style={{ marginBottom: "0.5rem" }}>
                Account Number - {account.account_number}
              </p>
              <p style={{ marginBottom: "0.5rem" }}>
                Available Balance - ${account.available_balance}
              </p>
              <p style={{ marginBottom: "0.5rem" }}>
                Currency Code - ${account.currency_code}
              </p>
              <p style={{ marginBottom: "0.5rem" }}>
                Routing Number - {account.routing_number}
              </p>
              <p style={{ marginBottom: "0.5rem" }}>
                Last Updated - {update_at_datetime}
              </p>
            </div>
          );
        })}
      </div>
    </li>
  );
};
